import React from 'react';
import ReactDOM from 'react-dom';
import ReactDOMServer from 'react-dom/server';

import './index.css';
import './shims/polyfills'

import Checkout from './Components/checkout/CheckoutApp';
import SearchApp from './Components/search/SearchApp';

var window = typeof window === 'undefined' ? {} : window;
window['React']          = global['React']          = React
window['ReactDOM']       = global['ReactDOM']       = ReactDOM
window['ReactDOMServer'] = global['ReactDOMServer'] = ReactDOMServer

window['Checkout']       = global['Checkout']       = Checkout
window['Search']         = global['Search']         = SearchApp




// WEBPACK FOOTER //
// ./src/index.js